import * as React from "react";
import { forwardRef } from "react";
const SvgText = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "text" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M2.1875 3.93451H11.8125M2.1875 7H11.8125M2.1875 10.0655H6.3125", stroke: "white", strokeWidth: 1.16667, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgText);
export { ForwardRef as ReactComponent };
